<template>
    <a href="/cart" class="btn btn_lg btn_cart btn_icontext">
        <i class="f7-icons icon_lg">cart</i><span>{{ amount }}</span><span class="d-none d-sm-inline"> р.</span>
    </a>
</template>

<script>
    export default {
        computed: {
            amount() {
                return this.$store.state.cart.amount;
            }
        },
    }
</script>
